











































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { OtherModel } from '@/model/charactersheets';

@Component
export default class Presentational extends Vue {
  @Prop() public others!: OtherModel;

  @Emit() public update(payload: OtherModel) {}

  private get values() {
    return this.others;
  }

  public updateValue(payload: OtherModel) {
    this.update(payload);
  }
}
